<template>
    <div class="home">
        <!-- 首屏图 -->
        <img class="home-img" v-bind:src="homeImg" alt="Responsive image">

        <!-- loading加载图 -->
        <div class="home-loading">
            <div v-show="showLoad" class="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </div>
    </div>
</template>

<script>
import { WEIXIN } from '../modules/weixin';
export default {
    name: 'Home',
    data(){
        return {
            homeImg: require('../assets/images/home.png'),
            showLoad: true
        }
    },
    mounted: function() {
        var contentDiv = document.getElementsByClassName("home")[0];
        contentDiv.style = 'width:' + window.innerWidth + 'px; ' + 'height:' + window.innerHeight + 'px';

        // 禁止滚动
        contentDiv.addEventListener("touchmove", function(e){
            e.preventDefault()
        }, false);

        // 屏幕改变大小重置高度
        window.onresize = function(){
            contentDiv.style = 'width:' + window.innerWidth + 'px; ' + 'height:' + window.innerHeight + 'px';
        }

        // Todo:优化
        var me = this;
        setTimeout(function(){
            me.showLoad = false;
            me.$router.replace('/collate');
            // me.$router.replace('/famouspedia');
        }, 20);
    }
}
</script>

<style scoped>
    
</style>
